import request from '../utils/request';

/**
 * 搜索文档列表
 * /document/searchDocumentList
 */
export function searchDocumentList(query) {
    return request({
        url: '/document/searchDocumentList',
        method: 'get',
        params: query
    })
}

/**
 * 通过分类ID查找文档列表
 * /document/documentList
 */
export function documentList(query) {
    return request({
        url: '/document/documentList',
        method: 'get',
        params: query
    })
}

/**
 * 通过文档关键字查找文档详情
 * /document/documentDetailByKeywords
 */
export function documentDetailByKeywords(keywords) {
    return request({
        url: '/document/documentDetailByKeywords',
        method: 'get',
        params: { keywords }
    })
}

/**
 * 通过文档ID查找文档详情
 * /document/documentDetail
 */
export function documentDetail(id) {
    return request({
        url: '/document/documentDetail',
        method: 'get',
        params: { document_id: id }
    })
}